'use client';

import { motion } from 'motion/react';
import { useId } from 'react';

import MotionPath from '~/components/atoms/MotionPath';

interface Props {
  className?: string;
  isParentIntersecting: boolean;
}

const Quatrefoil: React.FC<Props> = ({ className, isParentIntersecting }) => {
  const gradientId = 'quatrefoil--' + useId();

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-2 -2 244 244"
      className={className}
      initial="hidden"
      animate={isParentIntersecting ? 'visible' : 'hidden'}
      variants={{
        hidden: {
          opacity: 0,
          scale: 2,
          transition: { duration: 1.4 },
        },
        visible: {
          opacity: 1,
          scale: 1,
          transition: {
            scale: { duration: 0 },
          },
        },
      }}
    >
      <defs>
        <motion.linearGradient
          id={gradientId}
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2="0"
          y2="720"
          variants={{
            hidden: {
              gradientTransform: 'translate(0 0)',
              transition: { duration: 1.4, delay: 0 },
            },
            visible: {
              gradientTransform: 'translate(0 -480)',
              transition: { duration: 1.4, delay: 0.4, ease: 'easeOut' },
            },
          }}
        >
          <stop offset="33%" stopColor="currentColor" stopOpacity="0" />
          <stop offset="66%" stopColor="currentColor" />
        </motion.linearGradient>
      </defs>

      <MotionPath
        d="m 120,0 c 21.982,0 39.861,17.883 39.861,39.861 0,21.978 18.067,40.278 40.278,40.278 22.21,0 39.861,17.883 39.861,39.861 0,21.978 -17.883,39.861 -39.861,39.861 -21.978,0 -40.278,18.067 -40.278,40.278 C 159.861,222.349 141.978,240 120,240 98.018,240 80.139,222.117 80.139,200.139 80.139,178.161 62.072,159.861 39.861,159.861 17.651,159.861 0,141.982 0,120 0,98.018 17.883,80.139 39.861,80.139 61.839,80.139 80.139,62.072 80.139,39.861 80.139,17.651 98.018,0 120,0"
        fill={`url(#${gradientId})`}
        className="stroke-brand-primary/10"
        strokeLinejoin="round"
        generateMotionProps={({ pathLength }) => {
          if (pathLength <= 0) {
            return {
              strokeWidth: 0,
              strokeDasharray: 0,
              strokeDashoffset: 0,
            };
          }

          return {
            strokeWidth: 0,
            strokeDasharray: pathLength,
            strokeDashoffset: pathLength,

            variants: {
              hidden: {
                strokeDashoffset: pathLength,
                transition: { duration: 0, delay: 0 },
              },
              visible: {
                strokeDashoffset: 0,
                transition: { duration: 1.6, ease: 'circOut' },
              },
            },
          };
        }}
      />
    </motion.svg>
  );
};

export default Quatrefoil;
